import type { ComponentProps } from 'react'

import { ICON_DEFAULT_COLOR, ICON_DEFAULT_FILL, type IconProps } from 'components'

export const BrazilFlag = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = '24', // TODO: Replace with ICON_DEFAULT_WIDTH when migration to ION is complete
  height = '24', // TODO: Replace with ICON_DEFAULT_HEIGHT when migration to ION is complete
  viewBox = '0 0 24 24', // TODO: Replace with ICON_DEFAULT_VIEWBOX when migration to ION is complete
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox={viewBox}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 17.5385C23 18.1913 22.7425 18.8174 22.284 19.279C21.8256 19.7407 21.2039 20 20.5556 20H3.44444C2.79614 20 2.17438 19.7407 1.71596 19.279C1.25754 18.8174 1 18.1913 1 17.5385V6.46154C1 5.8087 1.25754 5.1826 1.71596 4.72097C2.17438 4.25934 2.79614 4 3.44444 4H20.5556C21.2039 4 21.8256 4.25934 22.284 4.72097C22.7425 5.1826 23 5.8087 23 6.46154V17.5385Z"
        fill="#009B3A"
      />
      <path d="M21.0004 12L12 18.8455L2.99956 12L12 5.15385L21.0004 12Z" fill="#FEDF01" />
      <path
        d="M11.9853 15.9274C14.165 15.9274 15.9319 14.1481 15.9319 11.9532C15.9319 9.75837 14.165 7.97908 11.9853 7.97908C9.80571 7.97908 8.03878 9.75837 8.03878 11.9532C8.03878 14.1481 9.80571 15.9274 11.9853 15.9274Z"
        fill="#002776"
      />
      <path
        d="M8.50261 10.0843C8.29757 10.4732 8.15876 10.8941 8.09194 11.3292C10.5333 11.1508 13.8468 12.4929 15.2688 14.1569C15.5145 13.7852 15.6966 13.3692 15.8084 12.9237C14.0533 11.1957 10.9703 10.0745 8.50261 10.0843Z"
        fill="white"
      />
    </svg>
  )
}
